import React from "react";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/Endpoint";
import loadable from "@loadable/component";
import { tw } from "@careinfo/tailwind";
const CreateAccountComponent = loadable(
  () => import("../../components/AccountInfo/CreateAccount")
);

const CreateAccount = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["account-info"],
    navigateURL: "/accounting/account",
  });
  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.COA;
    const formData = {
      ...values,
      is_group: false,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <div>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>Create Account</h1>
      </div>
      <CreateAccountComponent
        handleCreate={handleCreate}
        isLoading={isPostLoading}
      />
    </div>
  );
};

export default CreateAccount;
